import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  documents: [],
  categories: []
};

const slice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET DOCUMENTS
    getDocumentsSuccess(state, action) {
      state.isLoading = false;
      state.documents = action.payload;
    },

    // GET CATEGORIES
    getCategoriesSuccess(state, action) {
        state.isLoading = false;
        state.categories = action.payload;
      },


  },
});

// Reducer
export default slice.reducer;


export function getDocuments() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/documents');

      dispatch(slice.actions.getDocumentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCategories() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/document/categories');
  
        dispatch(slice.actions.getCategoriesSuccess(response.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }
